import { render, staticRenderFns } from "./searchPtenDeduplicate.vue?vue&type=template&id=61cb2832"
import script from "./searchPtenDeduplicate.vue?vue&type=script&lang=js"
export * from "./searchPtenDeduplicate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports